export const isNotProd = () => window.location.hostname !== 'beta.console.hayden.ai';

export const isProd = () => window.location.hostname === 'beta.console.hayden.ai';

export const isStaging = () => window.location.hostname === 'staging.console.hayden.ai';

export const isTest = () => window.location.hostname === 'test.console.hayden.ai';

export const isEUprod = () => window.location.hostname === 'eupilot.console.hayden.ai';

export const isNotDev = () => window.location.hostname !== 'localhost';
